import * as TaskCards from 'components/tasks/list/TaskCards';
import * as TaskGroup from 'components/tasks/list/TaskGroup';
import { useTaskDrawerState } from 'components/tasks/useTaskDrawerState';
import { useInfiniteTasks } from 'components/tasks/utils/useInfiniteTasks';
import {
    taskFilterValuesSelector,
    useTasksFilterStore,
} from 'components/tasks/utils/useTasksFilterStore';
import { useFiltersCache } from 'contexts/useFiltersCache';
import useDebounce from 'customHooks/useDebounce';
import { useIsPending } from 'customHooks/useIsPending';

const ArchivedTaskGroup = () => {
    const { query, ...rest } = useTasksFilterStore(taskFilterValuesSelector);
    const { setSelectedTaskId } = useTaskDrawerState();

    const { getRequestFilters } = useFiltersCache(state => ({
        getRequestFilters: state.getRequestValuesByKey,
    }));
    const requestFilters = getRequestFilters('tasks');

    const debouncedQuery = useDebounce(query);

    const [, params] = useIsPending(
        {
            query: debouncedQuery.trim(),
            ...rest,
        },
        500,
    );

    const {
        ref: archivedInfiniteRef,
        data: { tasks: archivedTasks, meta: archivedMeta },
    } = useInfiniteTasks({
        ...params,
        filters: requestFilters,
    });

    return (
        <TaskGroup.Root id={'archived'}>
            <TaskGroup.Container>
                <TaskGroup.Header>
                    <div className="flex items-center gap-2">
                        <TaskGroup.CollapseTrigger />
                        <TaskGroup.Title>📦 Archived</TaskGroup.Title>
                        <TaskGroup.Count>{archivedMeta?.total}</TaskGroup.Count>
                    </div>
                </TaskGroup.Header>

                <TaskGroup.Content>
                    {archivedTasks.length === 0 ? (
                        <TaskGroup.NotFound />
                    ) : (
                        <TaskCards.Root>
                            <ul className="flex w-full flex-col gap-4 px-8">
                                {archivedTasks.map(task => {
                                    return (
                                        <TaskCards.TaskCard
                                            key={task.id}
                                            task={task}
                                            onNavigate={() => {
                                                setSelectedTaskId(task.id);
                                            }}
                                        />
                                    );
                                })}
                                <div ref={archivedInfiniteRef} />
                            </ul>
                        </TaskCards.Root>
                    )}
                </TaskGroup.Content>
            </TaskGroup.Container>
        </TaskGroup.Root>
    );
};

export { ArchivedTaskGroup };
